import { render, staticRenderFns } from "./editBaddebt.vue?vue&type=template&id=3ca6a1ec&scoped=true"
import script from "./editBaddebt.vue?vue&type=script&lang=js"
export * from "./editBaddebt.vue?vue&type=script&lang=js"
import style0 from "./editBaddebt.vue?vue&type=style&index=0&id=3ca6a1ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca6a1ec",
  null
  
)

export default component.exports